import React, { forwardRef } from 'react';

import MUIStep, { StepProps as MUIStepProps } from '@material-ui/core/Step';

interface StepProps extends MUIStepProps {}

const Step = forwardRef<HTMLDivElement, StepProps>((props, ref) => {
  return <MUIStep {...props} ref={ref} />;
});

Step.displayName = 'Step';

export default Step;
